import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideEllipsis } from '@ng-icons/lucide';
import { classes } from '@spartan-ng/helm/utils';

@Component({
	selector: 'hlm-breadcrumb-ellipsis',
	exportAs: 'hlmBreadcrumbEllipsis',
	imports: [NgIcon],
	providers: [provideIcons({ lucideEllipsis })],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'data-slot': 'breadcrumb-ellipsis',
		role: 'presentation',
	},
	template: `
		<ng-icon name="lucideEllipsis" />
		<span class="sr-only">{{ srOnlyText() }}</span>
	`,
})
export class HlmBreadcrumbEllipsis {
	/** Screen reader only text for the ellipsis */
	public readonly srOnlyText = input<string>('More');

	constructor() {
		classes(() => 'size-5 [&>ng-icon]:text-[length:--spacing(4)] flex items-center justify-center');
	}
}
